/* The mention markup for a suggestion's cited source, so the excerpt renders
 * the source as the same chip a citation in note content would be — a real
 * mention, never a link: an anchor carrying an `href` parses as an ordinary
 * link and stops being a reference. Built through the DOM rather than by
 * string concatenation so a label holding `<` or `"` cannot break out of the
 * anchor.
 *
 * Reference and label are passed separately, and the label is the one derived
 * from the resolved resource — never the one the model wrote. It is marked
 * DERIVED rather than authored, which is the difference that makes it show:
 * `data-authored-label` is the model's prose and the mention honours it only
 * behind `ai-citation-mentions`, so a Composition chip would otherwise fall
 * back to the bare `Composition.title` with no date. A derived label has no
 * author to distrust, so the mention takes it either way. */
export function sourceMentionHtml(reference: string, label: string): string {
  const anchor = document.createElement('a')
  anchor.setAttribute('data-type', 'mention')
  anchor.setAttribute('data-reference', reference)
  anchor.setAttribute('data-derived-label', label)
  anchor.textContent = label
  return anchor.outerHTML
}
